import { animate, style, transition, trigger } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { RxIf } from '@rx-angular/template/if';

import { DIALOG_ROUTE_CONFIG } from '@core/constants/app.constants';
import { SideDialogStateService } from '@core/services/dialog/side-dialog-state.service';

@Component({
  selector: 'app-bottom-popup-dialog-animation',
  template: `
    <div *rxIf="isVisible$"
          [@slideInOut]="{value: null, params: {animationTime: dialogRouteConfig.animationTime}}"
         class="bottom-popup-dialog-animation">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./bottom-popup-dialog-animation.component.scss'],
  standalone: true,
  imports: [
    RxIf,
  ],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('{{animationTime}}ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('{{animationTime}}ms ease-in', style({ transform: 'translateY(100%)' })),
      ]),
    ]),
  ],
})
export class BottomPopupDialogAnimationComponent {
  isVisible$ = this.sideDialogStateService.isVisible$;
  dialogRouteConfig = inject(DIALOG_ROUTE_CONFIG);

  constructor(
    private readonly sideDialogStateService: SideDialogStateService,
  ) {}
}
